// extracted by mini-css-extract-plugin
export default {"input":"formInput_input__vXyn6","error":"formInput_error__Fekkn"};